import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const amountOfCharactersValidator = (exactLength: number): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    return value && value.toString().length !== exactLength ?
      { amountOfCharacters: { exactLength } } : null;
  };
};

